// Full-document render of the Oscar free-gift configurator view: PageSkeleton
// (the React document shell) wrapping the `#configure-gifts-with-purchase-app`
// SPA mount point.
import React from "react";

import { templates } from "@reactivated";

import { ConfigureGiftsApp } from "../apps/checkout/ConfigureGiftsApp";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.ConfigureGiftsDocumentTemplate,
): React.JSX.Element => {
    return (
        // This mount is the page's own <main>, so PageSkeleton must not add
        // its default <main id="main-content"> wrapper (avoids nested <main>).
        <PageSkeleton pageChrome={props.page_chrome} wrapMain={false}>
            {/* The Configure-Gifts app lives in the document's React tree
                (mounted client-side by ConfigureGiftsApp; the dependency tree is
                not SSR-safe). This mount is the page's own <main>. */}
            <main
                id="configure-gifts-with-purchase-app"
                className="basket-container basket-container--configure-gifts"
            >
                <ConfigureGiftsApp />
            </main>
        </PageSkeleton>
    );
};
